import BasicInformationSection from './basic-information-section-view'
export default BasicInformationSection
